<template lang="html">
  <div class="group-question">
    <div class="group-question-picture">
      <img :src="picture"/>
    </div>
    <div class="group-question-body">
      <span>{{ body }}</span>
    </div>
    <div class="group-question-answer group-question-correct-answer">
      <div class="answer-correct">{{ $tr('responses.tabs.test.correctAnswer') }}</div>
      <div>{{ correctAnswer ? correctAnswer.body : '' }}</div>
    </div>
    <div v-if="candidateAnswer" class="group-question-answer group-question-candidate-answer">
      <div :class="{'answer-correct': candidateAnswerIsCorrect, 'answer-wrong': !candidateAnswerIsCorrect}">{{ $tr('responses.tabs.test.candidateAnswer') }}</div>
      <div>{{ candidateAnswer ? candidateAnswer.body : '' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'response-tabs-tab-test-group-question',

  props: {
    question: Object
  },

  data () {
    return {
      correctAnswer: null,
      candidateAnswer: null
    }
  },

  watch: {
    question (value) {
      this.init()
    }
  },

  computed: {
    picture () {
      return this.question.picture
    },

    body () {
      return this.question.body
    },

    candidateAnswerIsCorrect () {
      return this.correctAnswer && this.candidateAnswer && this.correctAnswer.id === this.candidateAnswer.id
    }
  },

  methods: {
    init () {
      if (Array.isArray(this.question.answers)) {
        this.correctAnswer = this.question.answers.find(answer => answer.is_valid === true)
        this.candidateAnswer = this.question.answers.find(answer => answer.is_chosen === true)
      }
    }
  },

  beforeMount () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.group-question {
  padding-top: 12px;
  font-size: 16px;
  font-weight: normal;
  max-width: inherit;

  .answer-correct {
    color: $green;
  }

  .answer-wrong {
    color: $red-color;
  }

  .group-question-picture {
    max-width: inherit;
    img {
      max-width: inherit;
    }
  }

  .group-question-body {
    padding-top: 24px;
    font-weight: 500;
  }

  .group-question-answer {
    padding-top: 24px;

    div + div {
      padding-top: 8px;
    }
  }
}
</style>
